import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IonPopover } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { asyncScheduler, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { INivelesPromo, IProductos, IPromosEcommerce, ISummaryPrice } from '../../../../private/shared/models/productos';
import { TransferDataService } from '../../../../private/shared/services/transfer-data.service';
import { addCartPromoState, removeCartPromoState } from '../../../../store/actions';
import { AppState } from '../../../../store/app-reducers';
import { buildConfirmRemovePromotion } from '../../../configs/modal-configs';
import { SummaryPriceDefault } from '../../../models/Constants';
import { ModalConfirm } from '../../../models/modal-confirm.model';
import { ModalsService } from '../../../services/modals/modals.service';
import { OperationsService } from '../../../services/operations/operations.service';
import { AddCartPage } from '../../add-cart/add-cart.page';
import { ILimitsToast } from './../../../models/ApplicationUser';
import { ToastControllerService } from './../../../services/toast-controller.service';

@Component({
  selector: 'add-products-buttons',
  templateUrl: './add-products-buttons.component.html',
  styleUrls: ['./add-products-buttons.component.scss'],
})
export class AddProductsButtonsComponent implements OnInit, OnChanges, OnDestroy {

  @ViewChild('tooltip', { static: true }) tooltip: IonPopover;

  @Input() exchange = 0;
  @Input() initial = 0;
  @Input() promo: IPromosEcommerce;
  @Input() promosCart: IPromosEcommerce;
  @Input() productosPromocion: IProductos[] = [];
  @Input() Niveles: INivelesPromo[] = [];

  @Output() addPromo = new EventEmitter<number>();
  @Output() addExchange = new EventEmitter<number>();

  public isDisabledButton: boolean = false;
  public isTooltip: boolean = false;

  private modalConfirmRemove: ModalConfirm
  private LimitMaxCajas = 0;
  private LimitMaxMonto = 0;
  private summaryPrice: ISummaryPrice = SummaryPriceDefault;
  private finishSubscriptions: Subject<boolean> = new Subject();

  constructor(
    private transferDataS: TransferDataService
    , private operationsS: OperationsService
    , private toastS: ToastControllerService
    , private translate: TranslateService
    , private modalS: ModalsService
    , private store: Store<AppState>
    , private route: Router
  ) { }

  ngOnInit() {
    this.modalConfirmRemove = buildConfirmRemovePromotion(this.translate)
    this.disabledBotton();
    this.LimitMaxCajas = this.operationsS.LimitMaxCajas;
    this.LimitMaxMonto = this.operationsS.LimitMaxMonto;
    this.operationsS.summaryPriceTotal$()
      .pipe(
        takeUntil(this.finishSubscriptions)
      )
      .subscribe(summaryPrice => this.summaryPrice = summaryPrice);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.Niveles || changes.productosPromocion) {
      this.disabledBotton();
    }
  }

  ngOnDestroy(): void {
    this.finishSubscriptions.next(true);
    this.finishSubscriptions.complete();
  }

  /** Agrega Promociones al estado del carrito */
  public onAddPromo = async () => {
    if (this.promo.TipoPromocion === 'DINAMICO' && this.Niveles.some(n => n.Maximo > n.Minimo)) return;
    this.tooltip.dismiss();

    // * Validación de precio maximo
    const cartProductsPrice = this.productosPromocion.map(p => p.precio * p.productos * this.promosCart.PaquetesCanjeados).reduce((a, b) => a + b);
    const productsPrice = this.productosPromocion.map(p => p.precio * p.productos * this.exchange).reduce((a, b) => a + b);
    const totalPrice = this.summaryPrice.total_precio - cartProductsPrice;
    const priceSelected = productsPrice + totalPrice;
    if (this.LimitMaxMonto > 0 && priceSelected > this.LimitMaxMonto) {
      await this.toastS.dismissToast();
      const { header, message, color, icon, duration, clase, position }: ILimitsToast = this.translate.instant('Toasts.limits-prices');
      this.toastS.presentToast(message.replace('{{limit}}', this.LimitMaxMonto.toString()), color, icon, duration, clase, position, header);
      return;
    }

    // * Validación de cajas maximo
    const cartProductsBoxs = this.productosPromocion.map(p => (p.FactorCl * p.productos) * this.promosCart.PaquetesCanjeados).reduce((a, b) => a + b);
    const productsBoxs = this.productosPromocion.map(p => (p.FactorCl * p.productos) * this.exchange).reduce((a, b) => a + b);
    const totalCajas = (this.summaryPrice.FactorCl - cartProductsBoxs) + productsBoxs;
    if (this.LimitMaxCajas > 0 && totalCajas > this.LimitMaxCajas) {
      await this.toastS.dismissToast();
      const { header, message, color, icon, duration, clase, position }: ILimitsToast = this.translate.instant('Toasts.limits-boxs');
      this.toastS.presentToast(message.replace('{{limit}}', this.LimitMaxCajas.toString()), color, icon, duration, clase, position, header);
      return;
    }

    if (this.exchange > this.initial) {
      this.store.dispatch(addCartPromoState({ promo: this.promo, cartPromos: this.productosPromocion, promoSelect: this.exchange }));
      this.addPromo.emit(0);
      if (!this.route.url.includes('Carrito')) {
        const imagen_url: string = this.translate.instant('Icons.generic-promo');
        asyncScheduler.schedule(() =>
          this.modalS.modalAddCart(AddCartPage, {
            ...this.promo,
            PaquetesCanjeados: this.exchange,
            Productos: this.productosPromocion.filter(p => p.productos > 0).map(p => ({ ...p, productos: p.productos * this.exchange })),
            imagen_url,
          })
          , 500);
      }
    } else {
      // Quita la promo del carrito
      const confirm = await this.modalS.modalConfirm(this.modalConfirmRemove)
      if (confirm) {
        this.store.dispatch(removeCartPromoState({ ClavePromo: this.promo.ClavePromo }));
        this.addPromo.emit(0);
      } else {
        this.addExchange.emit(1);
      }
    }
  }

  /** Comportamiento del boton dependiendo del tipo de promo */
  public disabledBotton = () => {
    let isDisabled = true;
    const minimum = (this.promosCart.Niveles || []).length > 0 ? this.promosCart.Niveles.find(n => n.Nivel === 1)?.Minimo || 0 : 0;
    const selected = this.transferDataS.sumTotal(this.productosPromocion, 'productos');
    switch (this.promo.TipoPromocion) {
      case 'DINAMICO':
        isDisabled = this.Niveles.some(n => n.Maximo > n.Minimo);
        break;
      case 'ESCALERA':
        isDisabled = !(selected >= minimum && this.exchange > 0);
        break;
      case 'ESTATICO':
        isDisabled = this.exchange === this.promosCart.PaquetesCanjeados;
        break;
      case 'BONIFICACION':
        isDisabled = this.Niveles.some(n => n.Maximo > n.Minimo);
        break;
      default:
        isDisabled = true;
    }

    this.isDisabledButton = isDisabled;
  }

  public ontooltip = (e: Event) => {
    if (!this.isDisabledButton) {
      this.tooltip.dismiss();
      return;
    }
    this.tooltip.event = e;
    this.isTooltip = true;
  }
}
